import { useState } from "react";
import {
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from "react-native";
import { useNavigation } from "@react-navigation/native";

// Components
import VisibilityData from "../../common/VisibilityData";
import Graph from "../../common/Graph";
import { TimeOption } from "../../common/Times";

// Data
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux";
import {
  selectWatchlistInsight,
  setBottomSheet,
  setEntity,
} from "../../../redux/mainSlice";
import { WatchlistID } from "../../../types/data";

// Styles
import { Colors, Spacing, Typography } from "../../../styles";
import Header from "./Header";
import { StackNavigationProp } from "@react-navigation/stack";

export interface WatchedCardProps {
  id: WatchlistID;
  timeOption: TimeOption;
  style?: ViewStyle;
}

const WatchedCard = ({ id, timeOption, style }: WatchedCardProps) => {
  const dispatch = useDispatch();
  const navigation = useNavigation<StackNavigationProp<any>>();

  const [width, setWidth] = useState<number>(0);

  // #region Data
  const watchlistInsight = useSelector((state: RootState) =>
    selectWatchlistInsight(state, id)
  );

  const visibility = watchlistInsight?.insight.visibilities.find(
    (v) => v.entity === watchlistInsight.entity
  );

  if (!visibility || !watchlistInsight) return <></>;
  //#endregion

  return (
    <TouchableWithoutFeedback
      onPress={() => {
        dispatch(setEntity(watchlistInsight.entity));

        navigation.push("Insight", {
          id: watchlistInsight.insightID,
        });
      }}
    >
      <View
        style={[styles.container, style]}
        onLayout={(e) => setWidth(e.nativeEvent.layout.width)}
      >
        <Header insight={watchlistInsight.insight} />
        <VisibilityData
          entity={watchlistInsight.entity}
          visibility={visibility}
          // visibility={visibility.data.slice(-1)[0]}
          // visibilityTarget={visibility.target}
        />
        <Graph data={visibility.data} timeOption={timeOption} />
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.plum700,
    borderRadius: Spacing.cardRadius,
    padding: Spacing.card,
  },
});

export default WatchedCard;
